import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconExpand: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="expand">
    <path d="M20 3.4h-5.6v1.2h4.151l-5.9 5.9.849.848 5.9-5.9V9.6h1.2V4a.6.6 0 0 0-.6-.6ZM4 20.6h5.6v-1.2H5.45l5.9-5.9-.849-.848-5.9 5.9V14.4H3.4V20a.6.6 0 0 0 .6.6Z" />
  </Icon>
);
